import { render, staticRenderFns } from "./TagFilter.vue?vue&type=template&id=52d414a4&scoped=true"
import script from "./TagFilter.vue?vue&type=script&lang=ts"
export * from "./TagFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d414a4",
  null
  
)

export default component.exports